import Vue from 'vue';
import FieldError from './FieldError.vue';
import FormError from './FormError.vue';

Vue.component('field-error', FieldError);
Vue.component('form-error', FormError);
